import { render, staticRenderFns } from "./ParagraphButton.vue?vue&type=template&id=ef646976&"
import script from "./ParagraphButton.vue?vue&type=script&lang=js&"
export * from "./ParagraphButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports